// extracted by mini-css-extract-plugin
export var addonDescription = "style-module--addonDescription--e5eee";
export var addonHeaderDesktop = "style-module--addonHeaderDesktop--ce8ab";
export var addonHeaderMobile = "style-module--addonHeaderMobile--2a7c7";
export var addonOptionColumn = "style-module--addonOptionColumn--0db9c";
export var addonRow = "style-module--addonRow--79bd8";
export var addonRowFourColumns = "style-module--addonRowFourColumns--9d826";
export var addonRowTwoColumns = "style-module--addonRowTwoColumns--f2b73";
export var addonTitle = "style-module--addonTitle--8ef2a";
export var addonWrapper = "style-module--addonWrapper--9a843";
export var request = "style-module--request--43dc8";